import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StatusVersionEnum } from '../../shared/services/enums/status-version.enum';
import { BookVersionService } from '../../shared/services/apis/platform/book-version.service';
import { CommonModule } from '@angular/common';
import { MenuComponent } from '../../shared/components/menu/menu.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { AlertService, AlertType } from '../../shared/services/alert.service';
import { BookVersionResponse } from '../../shared/services/responses/platform/book-version.response';
import { LoginValidationComponent } from '../login-validation.component/login-validation.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RedirectService } from '../../redirect-service';

@Component({
    selector: 'app-book-status',
    templateUrl: './book-status.component.html',
    styleUrls: ['./book-status.component.css'],
    standalone: true,
    imports: [CommonModule, MenuComponent, FooterComponent, LoginValidationComponent, MatProgressSpinnerModule],
})
export class BookStatusComponent implements OnInit {
    idBookVersion: number;
    currentStatus: StatusVersionEnum = StatusVersionEnum.Upload;
    step = 0; // Índice do passo atual
    public isLoading = true;

    stepsLabels = [
        'Submetido', // step 0
        'Em revisão', // step 1
        'Aguardando sua aprovação' // step 2
    ];

    constructor(
        private route: ActivatedRoute,
        private alertService: AlertService,
        private redirectService: RedirectService,
        private bookVersionService: BookVersionService
    ) { }

    ngOnInit(): void {
        this.idBookVersion = Number(this.route.snapshot.paramMap.get('idBookVersion'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    onLoginValidated(isLogged: boolean) {
        if (!isLogged) {
            return;
        }
        this.getBookVersion();
    }

    getBookVersion(): void {
        this.isLoading = true;
        this.bookVersionService.GetBookVersion(this.idBookVersion, StatusVersionEnum.RevisaoDaEditora).subscribe({
            next: (res: BookVersionResponse) => {
                if (res.isError) {
                    this.alertService.show('Erro', res.errorDescription, AlertType.error);
                    return;
                }
                this.redirectService.redirectByStatus(res.bookVersionStruct.idStatusVersion, this.idBookVersion, res.bookVersionStruct.isCreditReviewing);

                // Pegue o status vindo do backend
                this.currentStatus = Number(res.bookVersionStruct.idStatusVersion);
                this.step = this.getStepIndex(this.currentStatus); // Atualiza o step
                this.isLoading = false;
            },
            error: err => {
                this.alertService.show('Erro inesperado', err, AlertType.error);
                this.isLoading = false;
            }
        });
    }

    // Mapeia o status da versão para o índice correto na barra
    getStepIndex(status: StatusVersionEnum): number {
        switch (status) {
            case StatusVersionEnum.Upload:
                return 0; // Submetido
            case StatusVersionEnum.RevisaoDaEditora:
                return 1; // Em revisão
            case StatusVersionEnum.AguardandoAprovacaoDoAutor:
                return 2; // Aguardando aprovação
            default:
                return 0; // fallback
        }
    }

    getProgressWidth(): string {
        const totalSteps = 4;
        let percent = 0

        if (this.step <= 0) percent = 0;

        if (this.step >= totalSteps - 1) percent = 100;

        else percent = (this.step) * 100 / (totalSteps - 1);

        return (percent + percent / 2) + "%";
    }
}
